<template>
  <div id="app">
    <back-to-top bottom="50px" right="50px">
      <b-button variant="info"><small>Back to Top</small></b-button>
    </back-to-top>
    <Navbar />
    <div class="bg-light bg-body">
      <router-view/>
    </div>
    <Footer />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/common/css/main.css'

import Navbar from '@/common/Navbar.vue'
import Footer from '@/common/Footer.vue'

export default {
  name: 'App',
  components: { Navbar, Footer },
  data () {
    return {
      prevHeight: 0
    }
  },
  methods: {
    beforeLeave (element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter (element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter (element) {
      element.style.height = 'auto'
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
.bg-body {
  background-image: linear-gradient(#eee 1px, transparent 1px);
  background-size: 100% 1.8em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue